import styled from "@emotion/styled/macro";
import { Modal, Typography } from "@sunrun/experience-ui-components";
// eslint-disable-next-line import/no-restricted-paths
import { ErrorType, FileUploadError } from "./UploadAttachments";

type UploadErrorModalProps = {
  errors: FileUploadError[];
  onClose: () => void;
};

const UploadErrorModal = ({ errors, onClose }: UploadErrorModalProps) => {
  if (!errors.length) {
    return null;
  }
  const errorMessage =
    errors.length > 1
      ? "These files could not be uploaded."
      : "This file could not be uploaded.";

  return (
    <Modal
      testId="upload-error-modal"
      type="error"
      title={errorMessage}
      onClose={onClose}
      primaryButton={{ text: "Retry", onClick: () => onClose() }}
    >
      <TextContainer>
        {errors.map((file) => (
          <Typography key={file.fileName}>{file.fileName}</Typography>
        ))}
      </TextContainer>
    </Modal>
  );
};

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export type { UploadErrorModalProps, FileUploadError };
export { UploadErrorModal, ErrorType };
